//Tagging For Git

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { creator } from 'd3';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-re-create',
  templateUrl: './re-create.component.html',
  styleUrls: ['./re-create.component.scss']
})
export class ReCreateComponent {

  @Input() request: any;
  @Input() skillTypeId: string = "";
  @Input() trainingCreator: any;

  @Output() reCreated = new EventEmitter<any>();

  public createCourseForm: FormGroup = new FormGroup({
    timeline: new FormControl(),
    sessionForm: this.formBuilder.array([])
  });
  dateType = "range";
  trainingDetails: any;
  sessionIds: [] | any;
  checkDate!: boolean;
  errorMessage!: string;
  createdFrom: any;
  errorMessageTime: string = '';
  spinner: boolean = false;
  pendingUsers: any


  constructor(
    private dataService: DataService,
    private formBuilder: FormBuilder) { }
  ngOnInit() {

    this.request
    

    this.getPendingAttendeesData(this.request.pendingAttendees)
    this.reCreate(this.request);
  }

  async getPendingAttendeesData(attendees: any) {
    let query: any = { _id: { $in: attendees } }
    let res: any = await this.dataService.postData('user/get', query)
    if (res.error) return
    this.pendingUsers = res.data;
  }

  async reCreate(req: any) {
    try {
      let res = await this.dataService.getData('course/get/' + req.trainingId._id);

      if (res.error) {
        return
      }
      this.createdFrom = res.data[0];
      this.trainingDetails = res.data[0];


      this.createCourseForm.value.sessionForm = [];
      let sessionForm = this.createCourseForm.get('sessionForm') as FormArray
      sessionForm.controls = [];
      if (this.trainingDetails?.session && this.trainingDetails?.session?.length > 0) {

        this.trainingDetails?.session.forEach((session: any, index: number) => {

          sessionForm.push(new FormGroup({
            'date': new FormControl(null, Validators.required),
            'start_time': new FormControl(null, session?.type != 'SURVEY' ? Validators.required : null),
            'end_time': new FormControl(null, session?.type != 'SURVEY' ? Validators.required : null),
            'url': new FormControl(null, session?.typeId?.zoom_url ? Validators.required : null)
          }))
        });
      }

    } catch (error) {
      console.log(error);
    }
  }

  public get sessionFormArray() {
    return (this.createCourseForm.get('sessionForm') as FormArray).controls;
  }


  areFormArrayFieldsValid(formArray: FormArray): boolean {
    for (let i = 0; i < formArray.length; i++) {
      const formGroup = formArray.at(i) as FormGroup;
      if (!formGroup.valid) {
        return false;
      }
    }
    return true;
  }



  updateFormDateCheck(SelectedDate: any, index: number) {
    let sessionForm = this.createCourseForm.get('sessionForm') as FormArray;

    if (this.createCourseForm?.value?.timeline[0]?.toUTCString() && this.createCourseForm?.value?.timeline[1]?.toUTCString()) {
      let startDate = new Date(this.createCourseForm?.value?.timeline[0]?.toUTCString());
      let endDate = new Date(this.createCourseForm?.value?.timeline[1]?.toUTCString());
      if (!(startDate <= SelectedDate && endDate >= SelectedDate)) {
        sessionForm.controls[index].get('date')?.setValue(null);
        this.errorMessage = 'please select date in range';
      }

    }
    else {
      this.errorMessage = 'select Course date';
    }

  }

  startTimeChange(index: number) {
    let sessionForm = this.createCourseForm.get('sessionForm') as FormArray;
    let start = sessionForm.controls[index].get('start_time')?.value;
    let end = sessionForm.controls[index].get('end_time')?.value;
    let startTime = this.timeToMinutes(start);
    let endTime = this.timeToMinutes(end);
    if (!(startTime < endTime)) {
      let v = sessionForm.controls[index].get('end_time')?.setValue(null);
      this.errorMessageTime = 'End time should be greater than start time';
    }
    else this.errorMessageTime = '';
  }

  endTimeChange(index: number) {
    let sessionForm = this.createCourseForm.get('sessionForm') as FormArray;
    let start = sessionForm.controls[index].get('start_time')?.value;
    let end = sessionForm.controls[index].get('end_time')?.value;
    let startTime = this.timeToMinutes(start);
    let endTime = this.timeToMinutes(end);
    if (!(startTime < endTime)) {
      sessionForm.controls[index].get('end_time')?.setValue(null);
      this.errorMessageTime = 'End time should be greater than start time';
    }
    else this.errorMessageTime = '';
  }

  timeToMinutes(time: string) {
    if (time) {
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes;
    }
    return 0;
  }


  createRequest = async (trainingData: any) => {
    try {
      let data = {
        topic: trainingData.title,
        type: this.skillTypeId,
        description: trainingData.description,
        creator: this.request?.creator
      };
      
      let res = await this.dataService.postData('training-req/', data);
      if (res.error) {
        return false
      }
      else {
        return res
      }

    } catch (error) {
      console.log(error);
    }
  };

  async assAttendees(data: any) {
    try {

      let res = await this.dataService.postData('course/assign-attendees', data, 'PUT', false);
      if (!res.error) {
        return
      } else {
      }
    } catch (error) {
      console.log(error)
    }

  }

  // handle form submission  
  async onSubmit() {

    let sessionFormArray = this.createCourseForm.get('sessionForm') as FormArray;
    let checkValid = this.areFormArrayFieldsValid(sessionFormArray);

    if (checkValid && this.createCourseForm.valid) {
      this.spinner = true;

      try {

        let data: any = this.constructBasicCourseObject(this.createCourseForm.value);

        let request = await this.createRequest(data)
        data.request_id = request.data._id;

        let response: any = await this.dataService.postData('course/', data);
        this.trainingDetails._id = response?.data?._id;

        let req = {
          _id: request.data._id,
          status: 'TRAINING_CREATED',
          trainingId: response.data._id,
          createdType: 'COURSE',
          recreatedFrom: this.createdFrom._id,
          recreationCount: this.request?.recreationCount + 1,
          description: this.request?.description,
          numberOfAttendees: this.request?.numberOfAttendees,
          // ous: this.request?.ous,
          registrationType: this.request?.registrationType,
          topic: this.request?.topic,
          type: this.request?.type?._id


          //have to add trining id here
        }
        let res = await this.dataService.postData('training-req/', req, 'PUT', false);
        //save attendess
        // {
        //   let pay = {
        //     _id: request.data._id,
        //     attendees: this.request?.pendingAttendees
        //   }
        //   let res = await this.assAttendees(pay);
        // }

        // update old request for remove pendingAttendees
        {
          let req = {
            _id: this.request?._id,
            pendingAttendees: [],
            lastSessionPending: this.request?.pendingAttendees
          }
          let res = await this.dataService.postData('training-req/', req, 'PUT', false);

        }

        if (response.error == true) {
          console.log(response.error);

        }
        else {

          if (this.trainingDetails?.session && this.trainingDetails?.session?.length > 0) {


            let sessionForm = this.createCourseForm.get('sessionForm') as FormArray;


            let index = 0;

            for (const session of this.trainingDetails?.session) {
              let programRes: any;
              let typeId: any;

              if (session?.type == 'SESSION') {

                // save/add program
                if (sessionForm.controls[index].get('url')?.value) {

                  programRes = session?.typeId, sessionForm.controls[index].get('url')?.value

                }

                else typeId = session?.typeId?._id;

              }

              let sessionPay:any = {
                title: session?.title,
                courseId: this.trainingDetails._id,
                trainer: session?.trainer,
                zoom_url: programRes?.url,
                address: programRes?.address,
                video_url: session?.video_url,
                locationLink: session?.locationLink,
                sessionType: session?.sessionType,
                video_mode: session?.video_mode,
                type: session?.type,
                date: sessionForm.controls[index].get('date')?.value.toUTCString(),
                start_time: sessionForm.controls[index].get('start_time')?.value,
                end_time: sessionForm.controls[index].get('end_time')?.value,
                status: session?.status,
                active: true
              }

              if (session?.type == 'SURVEY') {
                sessionPay['surveyId'] = session.surveyId;
              } else if (session?.type == 'ASSESSMENT') {
                sessionPay['assessmentId'] = session.assessmentId
              }

              this.addSession(session?.type, sessionPay);

              index++;
            }
            this.spinner = false;
          }
        }
      } catch (error) {
        console.log(error)
        this.spinner = false;
      }
    }
    this.reCreated.emit(true);
    this.reload()
  }


  async addProgram(programData: any, newUrl: string) {
    let program = {
      "trainer": programData?.trainer,
      "is_online": programData?.is_online,
      "video_url": programData?.video_url,
      "zoom_url": newUrl,
      "address": programData?.address

    }
    program

    let response: any = await this.dataService.postData('program/', program);
    if (response.error == true) {
      // this.message = response.msg;

    }
    else {
      // this.message = response.msg;
      // await this.addSession('SESSION', response?.data?._id);

    }
  }

  async addSession(type: string, dataObj: any) {
    this.sessionIds = [];
    try {
      let response: any = await this.dataService.postData('session/', dataObj);


      if (response.error == true) {
        // this.message = response.msg;

      }

      else {
        // this.message = response.msg;
        this.sessionIds.push(response?.data?._id);
        // this.sessionIds
        // 
        // await this.updateCourse(dataObj?.type, this.sessionIds);
        // this.resetSession();

      }
    } catch (error) {
      console.log(error)

    }
  }


  // updating course after update session,survey,assessment and course.
  async updateCourse(type: string, sessionCourseIds?: any) {
    try {
      let payload: any;

      if (type == 'SESSION' || type == 'ASSESSMENT' || type == 'SURVEY') {

        payload = {
          "_id": this.trainingDetails?._id,
          "title": this.trainingDetails?.title,
          "description": this.trainingDetails?.description,
          "type": type,
          "image": this.trainingDetails?.image,
          "start_date": this.trainingDetails?.start_date,
          "end_date": this.trainingDetails?.end_date,
          "session": sessionCourseIds,
          "active": this.trainingDetails?.active,
          "courseMaterial": this.trainingDetails?.courseMaterial
        }

      }
      // courseMaterial
      else {

        payload = {
          "_id": this.trainingDetails?._id,
          "title": this.trainingDetails?.title,
          "description": this.trainingDetails?.description,
          "type": type ? type : this.trainingDetails?.type,
          "image": this.trainingDetails?.image,
          "start_date": this.trainingDetails?.start_date,
          "end_date": this.trainingDetails?.end_date,
          "session": this.trainingDetails?.session,
          "active": this.trainingDetails?.active,
          "courseMaterial": this.trainingDetails?.courseMaterial,
        }

      }

      let response: any = await this.dataService.postData('course/', payload, 'PUT', false);
      if (response.error == true) {

      }

      else {

      }
    } catch (error) {
      console.log(error)

    }
  }

  constructBasicCourseObject(form: any) {
    this.request;
    this.trainingDetails;

    this.trainingDetails.start_date = form.timeline[0].toUTCString();
    this.trainingDetails.end_date = form.timeline[1].toUTCString();
    return {
      title: this.trainingDetails?.title,
      request_id: this.trainingDetails?.request_id ? this.trainingDetails?.request_id : null,
      description: this.trainingDetails?.description,
      image: this.trainingDetails?.image,
      courseMaterial: this.trainingDetails?.courseMaterial,
      start_date: form.timeline[0].toUTCString(),
      end_date: form.timeline[1].toUTCString(),
      session: [],

    }


  }

  invalidDate: string = ''
  dateValidate(SelectedDate: any) {
    let today = new Date();


    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - (today.getDay() + 2) % 7);


    // Set the end of the week to the next Thursday
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    if (SelectedDate.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0)) {
      this.invalidDate = "The Date Has Passed";
      this.createCourseForm.controls['timeline'].setValue(null);
      return

    }

    const selectedDay = SelectedDate.getDay();

    if (selectedDay === 5 || selectedDay === 6) { // 5 is Friday, 6 is Saturday
      this.invalidDate = "Please select a date other than Friday or Saturday";
      this.createCourseForm.controls['timeline'].setValue(null);
      return
        ;
    }


    else if (this.dateType == "range" && !this.createCourseForm.value.timeline[1]) {
      this.createCourseForm.value.timeline
      this.invalidDate = "invalid Date select in range";

    }
    else this.invalidDate = "";
  }

  disbleDates(values: any) {
    let temp = new Date();
    let today = new Date(temp.getFullYear(), temp.getMonth(), temp.getDate(), 0, 0, 0);
    let SelectedDate = new Date(values.year, values.month, values.day, 0, 0, 0)
    if (SelectedDate.getTime() < today.getTime()) {
      return true;
    }
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - (today.getDay() + 2) % 7);
    // Set the end of the week to the next Thursday
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    if (SelectedDate < today) {
      return
    }
    const selectedDay = SelectedDate.getDay();
    if (selectedDay === 5 || selectedDay === 6) { // 5 is Friday, 6 is Saturday
      return true;
    }
    else return false;
  }
  disbleDates2(values: any, index: number) {
    let selectedDate = new Date(values.year, values.month, values.day, 0, 0, 0)

    let sessionForm = this.createCourseForm.get('sessionForm') as FormArray;
    if (!!this.createCourseForm?.value?.timeline[0]?.toUTCString() && !!this.createCourseForm?.value?.timeline[1]?.toUTCString()) {
      let startDate = new Date(this.createCourseForm?.value?.timeline[0]?.toUTCString());
      let endDate = new Date(this.createCourseForm?.value?.timeline[1]?.toUTCString());
      if (!(startDate <= selectedDate && endDate >= selectedDate)) {
        sessionForm.controls[index].get('date')?.setValue(null);
        //   this.errorMessage = 'please select date in range';
        return true;
      }

    }

    return false;
  }

  reload() {
    window.location.reload();
  }

}
